import React from 'react';
import AdminManageUsers from '../../components/admin/components/AdminManageUsers';

const ManageUser = () => {
    return <AdminManageUsers />;
};

export default ManageUser;
